import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";
import BlogSetupWizard from "./BlogSetupWizard";
import styles from "./BlogSetupWizard.module.css";

function BlogSetupModal(props) {

  const hideModal = () => {
    props.onHide();
  };

  const { onHide, ...other } = props;
  let modalProps = _.pick(other, Modal.BASIC_PROPS);
  return (
    <Modal {...modalProps} onHide={hideModal} backdrop="static">
      <Modal.Dialog>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Blog Setup</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body className={styles["modal-body"]} >
          <BlogSetupWizard onComplete={hideModal}/>
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
}

export default BlogSetupModal;
